import { mapState, mapActions, mapMutations } from 'vuex';

import MonitorWrapper from '@/components/monitor-wrapper.vue';
import ctt from '@/utils/const';
import { isFCBR, noop } from '@/utils/utils';
import Type from '@/store/mutation-type';
import { socketModsFilter } from '@/utils/modsFilter';
import { closeWindowListener } from '@/utils/socket';
import { unconnectTime } from '@/utils/dict';
import { subscribe } from '@/utils/mqtt/index';

export default {
  props: {
    eventId: String,
    deviceType: String
  },
  components: {
    MonitorWrapper
  },
  provide() {
    return {
      getDeviceType: () => this.deviceType,
      getLoading: () => this.loading
    };
  },
  data() {
    const texts = ['设备连接中, 请耐心等待', '数据加载中'];

    return {
      disableNotice: false,
      loading: {
        value: false,
        text: texts[1],
        texts
      },
      unsub: noop,
      destroyed: false
    };
  },
  computed: {
    ...mapState('mqtt', ['devicesDetail']),
    ...mapState('socket', ['singleDeviceDetail', 'deviceSNMap']),
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),

    sn() {
      return this.$attrs.sn || this.$route.params.sn;
    },
    unconnectTime() {
      const data = this.deviceSNMap[this.sn];
      const { runMode } = data;
      return unconnectTime[runMode || 0];
    },
    isHisDetail() {
      // 是否为历史详情页面
      return !!this.$route.params.eventId;
    }
  },
  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    ...mapActions('history', ['getHistoryDetailData']),
    ...mapMutations('socket', {
      getDeviceDetail: Type.GET_DEVICE_DETAIL
    }),
    showLoading() {
      if (this.disableNotice) return;

      this.loading.text = this.loading.texts[+this.isHisDetail];
      this.loading.value = true;
    },
    hideLoading() {
      if (this.disableNotice) return;

      if (!this.loading) return;
      const timer = setTimeout(() => {
        this.loading.value = false;
        clearTimeout(timer);
      }, 600);
    },
    showInitNotice() {
      if (this.disableNotice) return;

      if (!this.notify) {
        this.notify = this.$notify({
          title: this.$t('hint'),
          message: this.$t('设备初始化中提示模板'),
          customClass: 'notify-content-left',
          duration: 20000,
          type: 'warning'
        });
      }
    },
    hideInitNotice() {
      if (this.disableNotice) return;
      this.notify?.close?.();
      this.notify = null;
    },
    showTimeoutNotice() {
      if (this.disableNotice) return;
      this.loadingTimeOut = setTimeout(() => {
        if (this.destroyed) return;
        this.conNotify = this.$notify({
          title: this.$t('hint'),
          message: this.$t('设备断联提示模板', { sn: this.sn }),
          customClass: 'notify-content-left',
          type: 'warning',
          duration: 0
        });
      }, this.unconnectTime);
    },
    hideTimeoutNotice() {
      if (this.disableNotice) return;
      clearTimeout(this.loadingTimeOut);
      if (this.conNotify) this.conNotify.close();
    },
    sendMessage() {
      this.subDeviceDetail({ sn: this.sn });
      if ((isFCBR(this.deviceType) || ctt.PID_IndApp === this.deviceType) && !this._stopParamSub) {
        this._stopParamSub = subscribe('{prefix}/{userId}/socket/param/');
      }
    },
    unsubscribe() {
      this.unsubDeviceDetail({ sn: this.sn });
      if (this._stopParamSub) {
        this._stopParamSub();
        this._stopParamSub = null;
      }
    }
  },
  async created() {
    this.showLoading();
    this.removeListener = closeWindowListener(() => this.unsubscribe());
    if (!this.isHisDetail) {
      this.sendMessage();
      this.showTimeoutNotice();
      if (this.updateData) {
        let old = null;

        this.sockets.subscribe('/socket/detail', res => {
          if (!res || res.sn !== this.sn) return;
          if (old && res.beginTime - old.beginTime < 100) return;

          old = res;
          this.hideTimeoutNotice();
          this.showTimeoutNotice();
          socketModsFilter(this.deviceType, res);
          this.getDeviceDetail(res);
          if (res.runstate === ctt.RUNSTATE_COLLECT) {
            this.showInitNotice();
          }
          this.updateData?.(res);
          this.hideLoading();
        });

        this.sockets.subscribe('/socket/param', res => {
          this.updateThreshold && this.updateThreshold(res);
        });
      } else {
        this.hideLoading();
        this.hideTimeoutNotice();
      }
    }
  },
  beforeDestroy() {
    this.destroyed = true;
    this.unsubscribe();
    this.hideInitNotice();
    this.hideLoading();
    this.hideTimeoutNotice();
    this.removeListener?.();
  }
};
